import angular from 'angular';

import { ESNController } from './esn';
const ESNModule = angular.module('equipment.esn', []);

ESNModule.controller('ESNController', ESNController);

export default ESNModule.name;
